"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterColumn = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
var core_ui_1 = require("@newfront-insurance/core-ui");
var dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var react_1 = __importDefault(require("react"));
var hooks_1 = require("./footer/hooks");
function FooterColumn(_a) {
    var schemaProperty = _a.schemaProperty, accessor = _a.accessor, footer = _a.footer, footerType = _a.footerType;
    var rows = footer.rows;
    var footerValue = (0, hooks_1.useFooterValue)(rows, accessor, schemaProperty.inputType, footerType);
    if (!shouldRenderFooter(schemaProperty, footerType)) {
        return null;
    }
    return (react_1.default.createElement(core_ui_1.Stack, { direction: "horizontal", gap: 8, alignItems: "center" },
        react_1.default.createElement(core_ui_1.Text, { weight: 600, style: {
                textTransform: 'uppercase',
            } }, FooterTypeLabel[footerType]),
        react_1.default.createElement(core_ui_1.Text, null, footerValue)));
}
exports.FooterColumn = FooterColumn;
var FooterTypeLabel = (_a = {},
    _a[dsl_schema_api_1.SpreadsheetFooterType.SUM] = 'Sum',
    _a[dsl_schema_api_1.SpreadsheetFooterType.AVERAGE] = 'Avg',
    _a);
function shouldRenderFooter(schemaProperty, footerType) {
    return !!footerType && hooks_1.ENABLED_FOOTER_INPUT_TYPES.includes(schemaProperty.inputType);
}
